import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center flex flex-center" }
const _hoisted_2 = { class: "bottom-dialog-title text-l-b-3 q-ma-none" }
const _hoisted_3 = { class: "bottom-dialog-comment text-s-3 q-ma-none" }
const _hoisted_4 = {
  key: 0,
  class: "full-width"
}
const _hoisted_5 = {
  key: 1,
  class: "row full-width"
}

import { ref, toRefs } from 'vue';
import useLang from 'src/composables/useLang';

type propsType = {
  title: string;
  comment: string;
  singleInteraction?: boolean;
  button?: string;
  firstButton?: string;
  secondButton?: string;
  dialog: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomDialog',
  props: {
    title: {},
    comment: {},
    singleInteraction: { type: Boolean },
    button: {},
    firstButton: {},
    secondButton: {},
    dialog: { type: Boolean, default: false }
  },
  emits: [
  'onClickButton',
  'onClickFirstButton',
  'onClickSecondButton',
],
  setup(__props: any, { emit }) {

const props = __props;


const { dialog } = toRefs(props);

const { translate } = useLang();



const fixedWidth = ref((breakpoint: string) => {
  return breakpoint !== 'xs';
});

function onClickButton() {
  emit('onClickButton');
}

function onClickFirstButton() {
  emit('onClickFirstButton');
}
function onClickSecondButton() {
  emit('onClickSecondButton');
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _unref(dialog),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : null)),
    class: "common-bottom-dialog",
    position: "bottom",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: _normalizeClass(["bottom-dialog-outer", fixedWidth.value(_ctx.$q.screen.name) ? 'fixed-width' : ''])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createVNode(_component_q_icon, {
                name: "error_outline",
                color: "red",
                size: "3.125rem"
              }),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.comment), 1),
              _createVNode(_component_q_card_actions, null, {
                default: _withCtx(() => [
                  (_ctx.singleInteraction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_q_btn, {
                          class: "text-m-b bottom-dialog-button",
                          label: _ctx.button,
                          onClick: onClickButton
                        }, null, 8, ["label"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _withDirectives(_createVNode(_component_q_btn, {
                          flat: "",
                          class: "col text-m-b dialog-button first-button",
                          label: _ctx.firstButton,
                          onClick: onClickFirstButton
                        }, null, 8, ["label"]), [
                          [_directive_close_popup]
                        ]),
                        _createVNode(_component_q_space, { class: "dialog-space" }),
                        _withDirectives(_createVNode(_component_q_btn, {
                          class: "col text-m-b dialog-button second-button",
                          label: _ctx.secondButton,
                          onClick: onClickSecondButton
                        }, null, 8, ["label"]), [
                          [_directive_close_popup]
                        ])
                      ]))
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})